import { MdOutlineFileUpload,MdQuestionAnswer  } from "react-icons/md";
import { IoDocumentsSharp, IoSettingsSharp } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import { BsChatLeftTextFill } from "react-icons/bs"
import { MdPlayLesson } from "react-icons/md";

function SideBarItems({ isLarge }) {
  const loaction = useLocation();
  const sideItems = [
    {
      // You can add a main menu title here if needed, e.g., title: "CONTENT"
      submenus: [
        // {
        //   icon: <MdOutlineFileUpload  />, // Icon for managing content
        //   title: "Upload", // More professional title
        //   url: "/admin", // Assuming this is the correct URL for the upload/manage content page
        // },
        {
          icon: <IoDocumentsSharp className="text-lg"  />, // Icon for managing content
          title: "Manage Docs", // More professional title
          url: "/admin/docs", // Assuming this is the correct URL for the upload/manage content page
        },
           {
          icon: <MdQuestionAnswer className="text-lg" />, // Icon for managing content
          title: "Questions", // More professional title
          url: "/admin/questions", // Assuming this is the correct URL for the upload/manage content page
        },
         {
          icon: <IoSettingsSharp className="text-lg" />, // <-- New Icon
          title: "Bonus Settings",                                  // <-- New Title
          url: "/admin/settings",                             // <-- New URL
        },
         {
          icon: <BsChatLeftTextFill  className="text-lg" />, // <-- New Icon
          title: "Chat History",                                  // <-- New Title
          url: "/admin/chat-history",                             // <-- New URL
        },

          {
          icon: <MdPlayLesson className="text-lg"  />, // <-- New Icon
          title: "Manage Lessons",                                  // <-- New Title
          url: "/admin/lessons",                             // <-- New URL
        },
      ],
    },
   
  ];

  return (
    <>
      <div className="sidebar-items">
        {sideItems?.map((elm, ind) => {
          return (
            <>
              <div className="sidebar-categories">{elm.categories}</div>
              {elm.submenus.map((item, i) => {
                return (
                  <>
                    <Link className="linknone" to={item.url}>
                      <div
                        className={`sidebar-submenus  ${
                          loaction.pathname == item.url &&
                          "sidebar-submenus-active"
                        }`}
                      >
                        {item.icon}{" "}
                        <span
                          className={`er ${!isLarge && "visibility-hidden"}`}
                        >
                          {item.title}
                        </span>
                      </div>
                    </Link>
                  </>
                );
              })}
            </>
          );
        })}
      </div>
    </>
  );
}

export default SideBarItems;
